import Resin, { sanitize as sanitizeResin } from './Resin';
import PrepregView from '../components/common/materials/Prepreg';
import {
  PREPREG,
  DEFAULT_SPACE_BETWEEN_MATERIALS
} from '../constants/globals';
import { prepregConstructionToStr, prepregToString } from '../lib/material';
import {
  calcColor,
  calcGlassThickness,
  calcThickness,
  calcPressedThickness
} from '../lib/prepreg';

const sanitize = resins => ( 
  resins.map(resin => ({
    count: resin.count,
    material: sanitizeResin(resin.material)
  }))
)

export class Prepreg extends Resin {
  constructor(resins) {
    super(sanitize(resins));

    // These properties intended not to be changed once set
    this.type                 = PREPREG;
    this.view                 = PrepregView.displayName;
  }

  update(resin) {
    const materials = resin.materials ?
      Object.keys(resin.materials).map(key => resin.materials[key]) :
      [];
    const color = materials.length > 0 ? calcColor(materials) : this.color;
    const thickness =  materials.length > 0 ? calcThickness(materials) : this._thickness;
    const glassThickness = materials.length > 0 ? calcGlassThickness(materials) : this._glassThickness;
    const material = materials.length > 0 ? sanitize(materials) : this._material;
    const name = resin.name || this.name;
    return Object.assign(this, {
      _color: color,
      _thickness: thickness,
      _glassThickness: glassThickness,
      _material:  material,
      name
    });
  }

  get color() {
    if(this._color === undefined) {
      this._color =  calcColor(this.material);
    }
    return this._color;
  }

  get product() {
    return this.material.length > 0 ? this.material[0].material.product : 'Unknown';
  }

  get manufacturer() {
    return this.material.length >0 ?
      this.material[0].material.manufacturer :
      'Unknown';
  }

  get manufacturerId() {
    return this.material.length > 0 ?
      this.material[0].material.manufacturerId :
      -1;
  }

  get resinId() {
    return this.material.length > 0 ?
      this.material[0].material.resinId :
      -1;
  }

  get construction() {
    return this.material ?
      prepregConstructionToStr(this.material) :
      'N/A';
  }

  get glassThickness() {
    if (this._glassThickness === undefined) {
      this._glassThickness = calcGlassThickness(this.material);
    }
    return this._glassThickness;
  }

  get thickness() {
    if (this._thickness === undefined) {
      this._thickness = calcThickness(this.material);
    }
    return this._thickness;
  }

  get pressedThickness() {
    if (this._pressedThickness === undefined) {
      this._pressedThickness = calcPressedThickness(this);
    }
    return this._pressedThickness;
  }

  get dk() {
    return this.material.length > 0 ? this.material[0].material.dk: [];
  }

  get df() {
    return this.material.length > 0 ? this.material[0].material.df: [];
  }

  get spaceNeeded() {
    return this.thickness_px + DEFAULT_SPACE_BETWEEN_MATERIALS * 2;
  }

  get resinContentPercent() {
    // return this.material.resinContent ? this.material.resinContent * 100 : undefined;
    return this.material.length > 0 ? this.material[0].material.resinContent * 100 : undefined;
  }

  toString(unit) {
    return prepregToString(this.material, unit);
  }
}

export const anonymousPrepreg = () => new Prepreg(
  [{
     count: 1,
     material: { thickness: 0.0025, color: 0x00ff00 }
  }]
);

export default Prepreg;


// WEBPACK FOOTER //
// ./src/models/Prepreg.js